export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        "product__prepurchase--buyNowCta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buy Now"])},
        "product__noSizeSelected--label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please select a size"])},
        "product__prepurchase--oosErrorLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Out of stock. Please select an available size."])},
        "product__prepurchase--subscriptionStatusErrorLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please subscribe to buy"])},
        "product__prepurchase--nonSubscriberBuyNowCta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Join to Buy"])},
        "product__prepurchase--pausedUserBuyNowCta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unpause to Buy"])},
        "product__prepurchase--cancelledUserBuyNowCta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resubscribe to Buy"])}
      }
    }
  })
}
